import React from 'react';
import { LucideIcon } from 'lucide-react';

interface PracticeModeButtonProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  onClick: () => void;
  disabled?: boolean;
}

export const PracticeModeButton: React.FC<PracticeModeButtonProps> = ({
  icon: Icon,
  title,
  subtitle,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="flex-1 group relative inline-flex items-center justify-center px-6 py-4 bg-white border-2 border-gray-300 rounded-xl font-medium text-gray-900 hover:border-primary-500 hover:bg-primary-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
      aria-label={title}
    >
      <div className="flex flex-col items-center gap-2">
        <Icon className="h-6 w-6 text-gray-600 group-hover:text-primary-600 transition-colors" />
        <span className="text-base font-semibold">{title}</span>
        <span className="text-xs text-gray-500">{subtitle}</span>
      </div>
    </button>
  );
};